module.exports = __webpack_public_path__ + "assets/img/svg/developers/small-logo.svg?v=1750221896789";